import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { ScrollDebouncer } from "core/classes/scroll/scroll.debouncer.class";
import { ScrollAPI } from "core/classes/scroll/scroll.api.class";

let StickyElementOptions = {
  measureElementClassName: "stickyMeasure"
};

class StickyElement extends Class {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.setOptions(StickyElementOptions, options);
    this.fixed = false;
    this.addElementMeasure();
    this.setUpEvents();
    this.onScroll();
  }

  addElementMeasure() {
    this.$measure = $(
      '<div class="' + this.options.measureElementClassName + '"/>'
    );
    this.element.before(this.$measure);
  }

  setUpEvents() {
    var self = this;
    $(ScrollDebouncer).on("scroll", function() {
      self.onScroll();
    });
  }

  onScroll() {
    var scrollTop = ScrollAPI.getScrollTop();
    var elementTop = this.$measure.offset().top;
    if (scrollTop > elementTop) {
      this.fix();
    } else {
      this.unfix();
    }
  }

  fix() {
    if (this.fixed) return;
    this.element.addClass("fixed");
    $("body").addClass(this.options.bodyClass);
    this.fixed = true;
    $(window).trigger("abacus:stickyelement:fixed", this.element);
  }

  unfix() {
    if (!this.fixed) return;
    this.element.removeClass("fixed");
    $("body").removeClass(this.options.bodyClass);
    this.fixed = false;
    $(window).trigger("abacus:stickyelement:unfixed", this.element);
  }
}

export { StickyElement };



// WEBPACK FOOTER //
// ./Javascript/core/classes/scroll/sticky.element.js